import React from 'react';
import GmailAccountStats from '../Gmail/GmailAccountStats';
import { Select, SelectOption } from 'components/ui';
import { useFormContext } from 'react-hook-form';
import { useFetchGmailAccounts } from 'query/gmail';

const GmailField = props => {
  const { watch } = useFormContext();
  const { data: gmailAccounts } = useFetchGmailAccounts({
    refetchOnMount: true,
    refetchInterval: 1000 * 60 * 5,
  });

  const isMultiMode = watch('isMultiMode');
  const forceChoose = watch('force_choose');
  const accountList = isMultiMode
    ? []
    : gmailAccounts.filter(e => {
        return e.esp === forceChoose;
      });

  return (
    <>
      <label className="input-name">Sender's Email</label>
      <Select
        {...props}
        className="gmail-account-select"
        id="authorizedAccountId"
        optionFilterProp="children"
        showSearch
        value={isMultiMode ? '' : props.value}
      >
        <SelectOption value="0">Select Authorized Account</SelectOption>
        {accountList.map(gmailAccount => (
          <SelectOption
            disabled={
              gmailAccount.revoked ||
              gmailAccount.suspended_at ||
              gmailAccount.as_reply_to
            }
            key={gmailAccount.id}
            title={gmailAccount.display_name}
            value={gmailAccount.id}
          >
            <div>
              {gmailAccount.email}
              <GmailAccountStats {...gmailAccount} />
              {gmailAccount.suspended_at
                ? ' (Suspended)'
                : gmailAccount.revoked
                ? ' (Revoked)'
                : ''}
              {!!gmailAccount.as_reply_to && ' (Reply Only)'}
            </div>
          </SelectOption>
        ))}
      </Select>
    </>
  );
};

export default GmailField;
